import { TabItem } from 'component/Tabs/Tabs.types'

const countries = ['brasil', 'chile']

const initialTabs = countries.reduce(
  (acc: Record<string, TabItem[]>, country) => {
    acc[country] = []

    return acc
  },
  {}
)

const getTabsItems = (
  allTabs: TabItem[],
  availableTabs: Record<string, string[]> = {}
) =>
  countries.reduce((acc: Record<string, TabItem[]>, country: string) => {
    acc[country] = allTabs.filter((tab) =>
      availableTabs[country].includes(tab.uuid)
    )

    return acc
  }, initialTabs)

export default getTabsItems
